import { render, staticRenderFns } from "./NurseTest.vue?vue&type=template&id=5ac0b8d2&scoped=true&"
import script from "./NurseTest.vue?vue&type=script&lang=js&"
export * from "./NurseTest.vue?vue&type=script&lang=js&"
import style0 from "./NurseTest.vue?vue&type=style&index=0&id=5ac0b8d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac0b8d2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VDialog,VIcon,VSelect,VTextField})
